import { createAction, props } from '@ngrx/store';
import { IEntidad } from '@shared/interfaces/app.state.interfaces';

export const setEntidades = createAction(
    '[Entidades] Set Entidades',
    props<{ tipo: string; data: IEntidad[] }>()
);
